export const formatThousands = (value: string): string => {
  const [integerPart, ...rest] = value.split('.')

  return [integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ','), ...rest].join('.')
}
